module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"order":"Order","saveJson":"Save JSON","cancel":"Cancel"},"no":{"order":"Ordre","saveJson":"Lagre JSON","cancel":"Avbryt"}}')
  delete Component.options._Ctor
}
